document.addEventListener('alpine:init', () => {
  Alpine.data('ctrHeroHome', () => ({
    mediaQuery: null,
    onBreakpointChange: null,

    init() {
      this.syncVideos();

      this.mediaQuery = window.matchMedia('(max-width: 920px)');
      this.onBreakpointChange = () => this.syncVideos();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(this.onBreakpointChange);
      }
    },

    destroy() {
      if (!this.mediaQuery || !this.onBreakpointChange) return;

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
      } else if (this.mediaQuery.removeListener) {
        this.mediaQuery.removeListener(this.onBreakpointChange);
      }
    },

    getVideos() {
      return Array.from(this.$el.querySelectorAll('video.section-hero-home__video'));
    },

    isHidden(video) {
      const wrapper = video.closest('.desktop-video, .mobile-video');
      if (!wrapper) return false;
      return window.getComputedStyle(wrapper).display === 'none';
    },

    syncVideos() {
      this.getVideos().forEach((video) => {
        if (video.dataset.videoSuppressed === 'true') return;

        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.loop = true;

        if (this.isHidden(video)) {
          video.pause();
          return;
        }

        this.playVideo(video);
      });
    },

    playVideo(video) {
      if (!video || video.dataset.videoSuppressed === 'true') return;
      if (window.__ultraShouldSuppressVideo === true) return;

      video.muted = true;
      video.playsInline = true;

      const tryPlay = () => {
        if (!video.paused && !video.ended) return;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
        return;
      }

      video.addEventListener('loadeddata', tryPlay, { once: true });
      tryPlay();
    },
  }));
});
